export default {
    IN_PROGRESS: 1,
    CONCLUDED: 2,
    CANCELED: 3,
    REJECTED: 4,
}